import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useScrollIntoView from '../utilities/useScrollIntoView';

function BackToTopAnthor({ isShown }) {
  const [buttonStyle, setButtonStyle] = useState('back-to-top-hide');

  const onClickBackToTop = useScrollIntoView('premium-title');

  useEffect(() => {
    if (isShown) {
      setButtonStyle('back-to-top-show');
    } else {
      setButtonStyle('back-to-top-hide');
    }
  }, [isShown]);

  return (
    <div className={buttonStyle}>
      <div className='back-to-top-container'>
        <div className='icon-back-to-top' onClick={onClickBackToTop} role='presentation' />
      </div>
    </div>
  );
}

BackToTopAnthor.propTypes = {
  isShown: PropTypes.bool.isRequired
};

export default BackToTopAnthor;
